import { render } from "./AddSector.vue?vue&type=template&id=84c7cbb4&scoped=true"
import script from "./AddSector.vue?vue&type=script&lang=js"
export * from "./AddSector.vue?vue&type=script&lang=js"

import "./AddSector.vue?vue&type=style&index=0&id=84c7cbb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c7cbb4"]])

export default __exports__